<template>
    <div class="product__downloads v-spacing-prj2 py-prj mb-prj3@until-large">
        <slot />
    </div>
</template>

<script>

    export default {
        name: 'ButtonGroup',
    }
</script>
